export const POYLMESH_EXTN_NAME = 'polywallet';
export const APP_NAME = 'TokenTraxx';
export const TESTNET_CHAIN = 99999; // this is set by us for our purpose; there is no chain ID with this type
export const MAINNET_CHAIN = 999; // this is set by us for our purpose; there is no chain ID with this type

export const TICKER = '';


export interface WhitelistArtistType {
  artistHandle: string | null;
  artistImage: string;
  artistName: string;
  id: string;
  numOfCollections: number;
  slug: string;
  portfolio: string;
  nftPriceInPOLYX?: string;
  nftPriceInDollar: string;
  collectionCreationTxnHash: string;
  custodian?: string;
  assetId: string;
}

export const maxPurchaseLimitPerUser =
  process.env.NEXT_PUBLIC_POLYMESH_ENV === 'prod' ? 5 : 2;

export const randomSubStringInt =
  process.env.NEXT_PUBLIC_POLYMESH_ENV === 'prod' ? 6 : 5;

export const polymeshPortalRedirectUrl =
  process.env.NEXT_PUBLIC_POLYMESH_ENV === 'prod'
    ? 'https://portal.polymesh.network/portfolio'
    : `https://portal.polymesh.live/portfolio`;

export const getAssetIdFromTicker = (
  whitelistedArtistList: WhitelistArtistType[],
  ticker: string,
) => {
  const nftDetails = whitelistedArtistList.find((el) => el.slug === ticker);
  if (!nftDetails?.assetId) {
    return null;
  }
  return formatAssetId(nftDetails?.assetId || '');
};

function normalizeToSlug(name: string): string {
  return name
    .toLowerCase() // Convert to lowercase
    .replace(/\s+/g, '-') // Replace spaces with hyphens
    .replace(/[^\w-]+/g, ''); // Remove non-alphanumeric characters except hyphens
}

export const getArtistListingUrl = (whitelistedArtistList: WhitelistArtistType[], artistSlug: string) => {
  const whitelistedArtist = whitelistedArtistList.find(
    (artist) => normalizeToSlug(artist.artistName) === artistSlug
  );

  if (!whitelistedArtist) return null;

  return `/polymesh/${whitelistedArtist.slug}/listing/${whitelistedArtist.id}`;
};

export const getArtist = (whitelistedArtistList: WhitelistArtistType[], artistSlug: string) => {
  return whitelistedArtistList.find(
    (artist) => normalizeToSlug(artist.artistName) === artistSlug
  );
};

// Not yet used. Need to delete it
export const isVenueDeprecated =
  process.env.NEXT_PUBLIC_POLYMESH_ENV === 'prod';


  export const formatAssetId = (hexAssetId: string): string => {
    // Remove '0x' prefix if present
    const cleanHex = hexAssetId.replace('0x', '');
    
    // Insert hyphens at specific positions
    return [
      cleanHex.slice(0, 8),
      cleanHex.slice(8, 12),
      cleanHex.slice(12, 16),
      cleanHex.slice(16, 20),
      cleanHex.slice(20)
    ].join('-');
  };